<template>
      <div>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-dropdownlist :dataSource="statusList" v-model="status"
              :fields="fieldsStatus" name="statusCheck"  @change="statusChange" ></ejs-dropdownlist>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="reportTaskLogData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true' >
          <e-columns>
            <e-column field="id" :visible="false"></e-column>
            <e-column field="exeTime" :headerText="$t('Pm.reportTaskLog.exeTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="status" :headerText="$t('Pm.reportTaskLog.status')" :formatter='statusFormat' width="120" textAlign="Center"></e-column>
            <e-column field="message" :headerText="$t('Pm.reportTaskLog.message')"  width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="page.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getReportTaskLogList"
        ></ejs-pager>
      </div>
      </div>
</template>
<script>
import CustomDialog from "../../../components/common/CustomDialog";
import BasicLayout from '../../../layouts/BasicLayout';
import {ExcelExport} from '@syncfusion/ej2-vue-grids';

export default {
  name: 'pmReportTaskLogPage',
  provide: {
  },
  components: {
    CustomDialog,
    BasicLayout,
  },
  data() {
    return {
      reportTaskLogData: [],
      right: { show: true, crumb: `${this.$t('Pm.pmManagement')}`+'/' + `${this.$t('Pm.gnbManagement')}` + '/' + `${this.$t('Pm.reportTaskLogTile')}` },
      toolbarItems: [
        // { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
      ],
      reportTaskId: '',
      status: '',
      pageSettings: { pageSize: 10 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      dateFormat: {
        type: 'date', format: 'yyyy-MM-dd HH:mm:ss'
      },
      fieldsStatus: {
          text: "text",
          value: "value"
      },
      statusList: [
          { text: `${this.$t('Pm.reportTaskLog.all')}`, value: '' },
          { text: `${this.$t('Pm.reportTaskLog.statusSuccess')}`, value: '1' },
          { text: `${this.$t('Pm.reportTaskLog.statusFail')}`, value: '0' },
      ],
      screenHeight: document.body.clientHeight - 240
    };
  },
  methods: {
    statusFormat(grids, data) {
      if(data.status == 1){
        return `${this.$t('Pm.reportTaskLog.statusSuccess')}`;
      }else if(data.status == 0){
        return `${this.$t('Pm.reportTaskLog.statusFail')}`;
      }
    },
    statusChange(msg){
      this.status = msg.value;
      this.getReportTaskLogList();
    },
    init(reportTaskId){
      this.reportTaskId = reportTaskId;
      this.getReportTaskLogList();
    },
    getReportTaskLogList() {
      const url = '/lte/ems/pm/gnb/report/task/queryLog';
      const params = { params: {
        reportTaskId: this.reportTaskId,
        status: this.status,
        pageNo: parseInt(this.page.pageNo, 10),
        pageSize: parseInt(this.page.pageSize, 10)
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        if(result !=null && result.length > 0){
          result.forEach((v) => {
            if (!!v.exeTime) {
              let date = new Date();
              date.setTime(v.exeTime);
              v.exeTime = date;
            }
          });
        }
        That.reportTaskLogData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    refreshGrid() {
      this.getReportTaskLogList();
    },
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
